var first, last, onEscape;

function onKeyDown(event) {
	if (event.isComposing) {
    return;
  }

  switch (event.key) {
		case 'Esc': // fall through IE11
    case 'Escape':
			onEscape();
      event.preventDefault();
    break;
    case 'Tab':
      if (event.shiftKey && event.target === first) {
        last.focus();
        event.preventDefault();
      }
      if (!event.shiftKey && event.target === last) {
        first.focus();
        event.preventDefault();
      }
    break;
    default:
      // do nothing
  }
  return;
}

/**
 * Very simple focus trap. Will listen for Tab and shift+tab.
 * No checking other than whether you're focussed on the
 * first or last element.
 *
 * Will call escHandler when Esc is pressed.
 *
 * @param {HTMLElement} firstElement
 * @param {HTMLElement} lastElement
 * @param {Function} escHandler
 */
function trapFocus(firstElement, lastElement, escHandler) {
	// make elements global so we can access them from the event callback
	first = firstElement;
	last = lastElement;
	onEscape = escHandler;

	window.addEventListener('keydown', onKeyDown);
}

function trapFocusRemove() {
	first = undefined;
	last = undefined;
	onEscape = undefined;
	window.removeEventListener('keydown', onKeyDown);
}

export { trapFocus, trapFocusRemove };
